// extracted by mini-css-extract-plugin
module.exports = {"izquierda":"Contacto_izquierda__KUOcb","derecha":"Contacto_derecha__1fGri"};